import React from "react";
import ReactiveTimeline from "./ReactiveTimeline";
import { motion } from "framer-motion";
import { IconCloudDemo } from "../home/whatIDo/IconCloudDemo";
import SummarySkills from "./SummarySkills";
import Skills from "../skills/skills";
import ResumeAndHireMeButton from "./ResumeAndHireMeButton";
import Certification from "./Certification";
import PeopleReview from "./reviews/PeopleReview";

const AboutAndResume = () => {
  return (
    <section className="w-full px-4 sm:px-6 md:px-12 pb-16 bg-gradient-to-b from-blue-100 via-[#d8f3dc] to-[#f1faee] text-gray-800">
      <div className="grid gap-10 md:grid-cols-[40%_60%] items-start">
        {/* Left Column: IconCloud, Resume Button, Certification */}
        <div className="flex flex-col items-center justify-center w-full">
          <motion.div
            initial={{ x: -200, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeOut", delay: 1 }}
          >
            <div className="w-full max-w-xs sm:max-w-sm md:max-w-md">
              <IconCloudDemo />
            </div>
          </motion.div>

          <motion.div
            initial={{ x: -200, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeOut", delay: 1.5 }}
            className="mt-6"
          >
            <ResumeAndHireMeButton />
          </motion.div>

          <motion.div
            initial={{ x: -200, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeOut", delay: 2 }}
            className="w-full max-w-4xl mt-10"
          >
            <div className="bg-white p-4 sm:p-6 rounded-2xl shadow-lg">
              <Certification />
            </div>
          </motion.div>
        </div>

        {/* Right Column: Summary & Skills */}
        <div className="w-full">
          <SummarySkills />
        </div>
      </div>

      {/* Skills */}
      <div className="mt-12">
        <Skills />
      </div>

      {/* Experience */}
      <div className="mt-16">
        <div className="text-center pb-6">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold">Experience</h1>
          <div className="w-20 h-1 bg-blue-600 mx-auto mt-2 rounded-full"></div>
        </div>
        <ReactiveTimeline />
      </div>

      {/* Word on the Street */}
      <div className="mt-16">
        <div className="text-center pb-6">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold">Word on the Street</h1>
          <div className="w-20 h-1 bg-blue-600 mx-auto mt-2 rounded-full"></div>
        </div>
        <PeopleReview />
      </div>

      {/* Repeated Button at Bottom (Optional) */}
      <div className="mt-10 text-center">
        <ResumeAndHireMeButton />
      </div>
    </section>
  );
};

export default AboutAndResume;
